//#region src/utils/findLiteralMatches.ts
/**
* Lowercase without changing the string's length, so reported offsets index the caller's text.
*
* - `İ` (U+0130) is the only code point lowercasing to two code units, so it folds to `I` first.
*/
const foldCase = (text) => text.replaceAll("İ", "I").toLowerCase();
const canContain = (text, query) => !!query && query.length <= text.length;
const scan = (haystack, needle) => {
	const offsets = [];
	let at = haystack.indexOf(needle);
	while (at !== -1) {
		offsets.push(at);
		at = haystack.indexOf(needle, at + needle.length);
	}
	return offsets;
};
/** Whether `text` holds `query`, ignoring case; stops at the first occurrence. */
const hasLiteralMatch = (text, query) => canContain(text, query) && foldCase(text).includes(foldCase(query));
/**
* Start offsets of every occurrence of `query` in `text`, ignoring case unless `isCaseSensitive`.
*
* - Literal, not a regex: pasted queries of tens of KB exceed what V8 compiles as a regex.
* - Non-overlapping; an empty query matches nothing.
* - Not CodeMirror's `SearchCursor`: it would pull CodeMirror into the root barrel.
*/
const findLiteralMatches = (text, query, { isCaseSensitive = false } = {}) => {
	if (!canContain(text, query)) return [];
	return isCaseSensitive ? scan(text, query) : scan(foldCase(text), foldCase(query));
};
/**
* `findLiteralMatches` for many queries over one text, as `{ from, to }` ranges.
*
* - Folds `text` once, not once per term.
* - Ranges arrive in term order; ranges of different terms may overlap.
*/
const findLiteralTermMatches = (text, terms, { isCaseSensitive = false } = {}) => {
	const haystack = isCaseSensitive ? text : foldCase(text);
	return terms.flatMap((term) => {
		if (!canContain(text, term)) return [];
		return scan(haystack, isCaseSensitive ? term : foldCase(term)).map((from) => ({
			from,
			to: from + term.length
		}));
	});
};
//#endregion
export { findLiteralMatches, findLiteralTermMatches, hasLiteralMatch };

//# sourceMappingURL=findLiteralMatches-DgGLzyG0.js.map